import { EmbedFrame } from '../EmbedFrame';
import { resolveYouTubeEmbedUrl } from '../providers';

interface YouTubeEmbedProps {
  src?: string;
  url?: string;
  id?: string;
  title?: string;
  ratio?: string;
}

export function YouTubeEmbed({
  src,
  url,
  id,
  title,
  ratio,
}: YouTubeEmbedProps) {
  const embedUrl = resolveYouTubeEmbedUrl(src ?? url ?? id);
  if (!embedUrl) return null;

  return (
    <EmbedFrame ratio={ratio}>
      <iframe
        className='h-full w-full border-0'
        src={embedUrl}
        title={title ?? 'YouTube video player'}
        loading='lazy'
        referrerPolicy='strict-origin-when-cross-origin'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        allowFullScreen
      />
    </EmbedFrame>
  );
}
